import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";
import { ListChecks, Package, History, ChevronRight, MapPin, Building2, UserCircle } from "lucide-react";

const fmtPrice = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export default function AdminRequests() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/orders", { params: { status: "NEW" } }).then((r) => setOrders(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  return (
    <div data-testid="admin-requests-page">
      <div className="mb-6">
        <div className="lc-small-label mb-1">Back-office</div>
        <h1 className="display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3">
          <ListChecks className="w-7 h-7 text-[var(--lc-orange)]" />
          Nouvelles demandes
        </h1>
        <p className="text-sm text-[var(--lc-gray)] mt-1">À valider en fixant une date de livraison.</p>
      </div>

      {loading && <div className="text-sm text-[var(--lc-gray)]">Chargement…</div>}
      {!loading && orders.length === 0 && (
        <div className="lc-card p-10 text-center" data-testid="no-requests">
          <div className="text-base font-semibold">Aucune demande en attente</div>
          <p className="text-sm text-[var(--lc-gray)] mt-1">Toutes les demandes sont à jour.</p>
        </div>
      )}

      <div className="grid gap-3" data-testid="requests-list">
        {orders.map((o) => (
          <Link
            to={`/admin/orders/${o.id}`}
            key={o.id}
            data-testid={`request-row-${o.id}`}
            className="lc-card p-4 sm:p-5 grid sm:grid-cols-[1fr,auto] gap-3 hover:border-[var(--lc-orange)]/40 transition-colors"
          >
            <div>
              <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                <span className="font-mono text-xs text-[var(--lc-gray)]">{o.ref}</span>
                <StatusBadge status={o.status} />
                {o.company_name && (
                  <span data-testid={`request-company-badge-${o.id}`} className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[var(--lc-black)] bg-[var(--lc-surface-alt)] border border-[var(--lc-border)] px-1.5 py-0.5 rounded">
                    <Building2 className="w-3 h-3" />{o.company_name}
                  </span>
                )}
                {o.vendor_name && (
                  <span data-testid={`request-vendor-badge-${o.id}`} className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[var(--lc-orange)] bg-[var(--lc-orange-soft)] border border-orange-200 px-1.5 py-0.5 rounded">
                    <UserCircle className="w-3 h-3" />{o.vendor_name}
                  </span>
                )}
              </div>
              <div className="text-sm font-semibold flex items-start gap-1.5">
                <MapPin className="w-3.5 h-3.5 mt-0.5 text-[var(--lc-orange)] shrink-0" />
                {o.recipient?.first_name} {o.recipient?.last_name} — {o.arrival_address}
              </div>
              <div className="text-xs text-[var(--lc-gray)] mt-1">
                Souhait : {o.delivery_date_wanted ? new Date(o.delivery_date_wanted).toLocaleDateString("fr-FR") : "—"} · {o.distance_km} km · {o.package_name}
              </div>
            </div>
            <div className="flex items-center justify-between sm:flex-col sm:items-end gap-2">
              <div className="text-xl font-black text-[var(--lc-orange)] text-right">{o.on_quote ? "Sur devis" : fmtPrice(o.total_ttc)}</div>
              <ChevronRight className="w-4 h-4 text-[var(--lc-gray)]" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
